export const REACT_APP_INSTAGRAM_ACCESS_TOKEN="IGAGXpGgs3s6ZABZAGF2QlNiY3dkMXRKYWszM2U3RFh4akdDSm5hclF2dmFzZATdnQWYyUzBFMkZAyV0RyX0ZACUG5mdmRmdXdQMkZAjYW5jMDBuWkhNMVItc2JoZAUJ2WWVUWVhPLUdqNVc0aldRY2tjWlNaWWdYbWJfeGZAXT1FodXJuawZDZD"

export const REACT_APP_API_URL=process.env.REACT_APP_API_URL || "http://localhost:5000";

